import Hero from '../components/Hero';
import NextToEvent from '../components/NextToEvent.js';
import Gallery from '../components/Gallery.js';
import TicketInfo from './TicketInfo';
import { useCart } from '../hooks/useCart';
import Steps from '../components/Steps.jsx';
import Intro from '../components/Intro';
import Footer from '../components/Footer';
import { useLang } from '../hooks/useLanguage.js';
import TripAdvisorWidget from '../components/TripAdvisorWidget';
import ShowDatePicker from './ShowDatePicker.js';
import MobileBottomBar from '../components/MobileBottomBar';
import { ShowSuccessResponseResponse } from '../../openapi/model/showSuccessResponseResponse.js';

const CURRENT_STEP = 1;

function Step1({
    setStep,
    show,
    showId,
    delayedSeatAssignmentEnabled = false,
}: {
    setStep: (step: number) => void;
    show: ShowSuccessResponseResponse;
    showId: number;
    delayedSeatAssignmentEnabled?: boolean;
}) {
    const { timeslot } = useCart();
    const { t } = useLang();

    return (
        <div className="fireknife-step fireknife-step1">
            <div className="fireknife-step__main fireknife-step1__main">
                <Hero show={show} />

                <div className="fireknife-step1__tickets-info">
                    <TicketInfo show={show} />
                </div>

                <div className="fireknife-step1__gallery">
                    <Gallery show={show} />
                </div>

                {/* TODO: it doesn't synchronized when changing the year/month */}
                <div className="fireknife-step1__datepicker">
                    <ShowDatePicker
                        showId={showId}
                        location="main"
                        rentalMode={!!show.marketing?.rentalMode}
                    />
                </div>

                <div className="fireknife-step1__intro">
                    <Intro show={show} />
                </div>

                {show.tripadvisorRating != null &&
                    show.tripadvisorReviews != null &&
                    show.tripadvisorReviews > 0 &&
                    show.tripadvisorUrl && (
                        <div className="fireknife-step1__tripadvisor">
                            <TripAdvisorWidget
                                rating={show.tripadvisorRating}
                                reviewCount={show.tripadvisorReviews}
                                link={show.tripadvisorUrl}
                            />
                        </div>
                    )}

                <Footer />
            </div>
            <aside className="fireknife-step__aside fireknife-step1__aside">
                <MobileBottomBar
                    showFees={show.fees}
                    isBreakingOutFees={show.isBreakingOutFees}
                    priceListingMode={show.priceListingMode}
                    cardProcessingFee={show.cardProcessingFee}
                    nextStep={() => setStep(CURRENT_STEP + 1)}
                    label={t('widgetStepNavigation.step1next')}
                    disabled={timeslot === null}
                />
                <div className="fireknife-step__aside-content">
                    <div className="fireknife-step1__next-to-event">
                        <Steps
                            step={1}
                            setStep={setStep}
                            showId={show.id}
                            delayedSeatAssignmentEnabled={delayedSeatAssignmentEnabled}
                            rentalMode={!!show.marketing?.rentalMode}
                        ></Steps>
                    </div>
                </div>
                <NextToEvent
                    nextStep={() => setStep(CURRENT_STEP + 1)}
                    label={t('widgetStepNavigation.step1next')}
                    disabled={timeslot === null}
                    showFees={show.fees}
                    isBreakingOutFees={show.isBreakingOutFees}
                    priceListingMode={show.priceListingMode}
                    cardProcessingFee={show.cardProcessingFee}
                />
            </aside>
        </div>
    );
}

export default Step1;
